import { render } from "./BuildYourCareer.vue?vue&type=template&id=0c8a2efe"
import script from "./BuildYourCareer.vue?vue&type=script&lang=js"
export * from "./BuildYourCareer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__